import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DataTable from "@insite/mobius/DataTable";
import { getDiscontinuedProductListFilters } from "@tIntermatic/Store/Components/DiscontinuedProductFilter/DiscontinuedProductListFilterSelector";
import addDiscontinuedProductsFilters from "@tIntermatic/Store/Components/DiscontinuedProductFilter/Handlers/AddDiscontinuedProductListFilter";
import loadDiscontinuedProductsFilters from "@tIntermatic/Store/Components/DiscontinuedProductFilter/Handlers/LoadDiscontinuedProductListFilter";
import removeAllDiscontinuedProductsFilters from "@tIntermatic/Store/Components/DiscontinuedProductFilter/Handlers/RemoveAllDiscontinuedProductListFilter";
import removeDiscontinuedProductsFilters from "@tIntermatic/Store/Components/DiscontinuedProductFilter/Handlers/RemoveDiscontinuedProductListFilter";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DiscontinuedProductsListFiltersAccordionSection from "@tIntermatic/Widgets/FilterTypeAccordionSection";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import isMobile from "ismobilejs";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import CustomApplicationState from "@tIntermatic/Store/CustomApplicationState";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import Search from "@tIntermatic/Icons/Search";
import { PaginationPresentationProps } from "@insite/mobius/Pagination/Pagination";
import getColor from "@insite/mobius/utilities/getColor";

export interface DiscontinuedProductList {
    fields: {
        [fields.replacementProductId]: string;
        [fields.isReplacementProductAvailable]: boolean;
        [fields.discontinuedProductId]: string;
        [fields.isDiscontinuedProductAvailable]: string;
        [fields.type]: string;
        [fields.category]: string;
    };
}

interface State extends CustomApplicationState {
    isFiltered: boolean;
    typesData: FacetModel[];
    categoriesData: FacetModel[];
    discontinuedProductListData: DiscontinuedProductList[];
}

const enum fields {
    title = "title",
    discontinuedProductList = "discontinuedProductList",
    replacementProductId = "replacementProductId",
    isReplacementProductAvailable = "isReplacementProductAvailable",
    discontinuedProductId = "discontinuedProductId",
    isDiscontinuedProductAvailable = "isDiscontinuedProductAvailable",
    type = "type",
    category = "category",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.discontinuedProductList]: DiscontinuedProductList[];
    };
}

const mapStateToProps = (state: CustomApplicationState, ownProps: WidgetProps) => {
    const types: string[] = ownProps.fields.discontinuedProductList.map((dp: { fields: { type: string } }) => {
        return dp.fields.type;
    });
    const typesListFiltered = types.filter(function (elem, pos) {
        // eslint-disable-next-line eqeqeq
        return types.toLocaleString().toLowerCase().indexOf(elem) == pos;
    });
    const typesList: FacetModel[] = typesListFiltered.map<FacetModel>(o => ({
        id: o,
        name: o,
        count: 1,
        selected: false,
    }));

    const categories: string[] = ownProps.fields.discontinuedProductList.map((dp: { fields: { category: string } }) => {
        return dp.fields.category;
    });
    const categoriesListFiltered = categories.filter(function (elem, pos) {
        // eslint-disable-next-line eqeqeq
        return categories.toLocaleString().toLowerCase().indexOf(elem) == pos;
    });
    const categoriesList: FacetModel[] = categoriesListFiltered.map<FacetModel>(o => ({
        id: o,
        name: o,
        count: 1,
        selected: false,
    }));

    let discontinuedProductsList = 
    ownProps.fields.discontinuedProductList.map((discontinuedProduct: DiscontinuedProductList) => {
        return {
            ...discontinuedProduct,
        };
    });

    return {
        typesList,
        categoriesList,
        discontinuedProductsList,
    };
};

const mapDispatchToProps = {
    getDiscontinuedProductListFilters,
    addDiscontinuedProductsFilters,
    loadDiscontinuedProductsFilters,
    removeAllDiscontinuedProductsFilters,
    removeDiscontinuedProductsFilters,
};

export interface DiscontinuedWidgetListStyle {
    dataTable: InjectableCss;
    pagination?: PaginationPresentationProps;
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    tableContainer?: InjectableCss;
    Rlptitle?: InjectableCss;
    listWrapper?: InjectableCss;
    subResourceNameLinkItem?: GridItemProps;
    columnHeader?: InjectableCss;
    columnData?: InjectableCss;
    cellCss?: InjectableCss;
    languageCellCss?: InjectableCss;
    typeLinks?: LinkPresentationProps;
    modelLinks?: LinkPresentationProps;
    ResourceContainer?: GridContainerProps;
    ResourceListContainer?: GridItemProps;
    ResourceListItemContainer?: GridItemProps;
    modelLinksText?: InjectableCss;
    searchTextField?: TextFieldPresentationProps;
    tableDataColThree?: InjectableCss;
    tableLinkData?: InjectableCss;
}
export const DiscontinuedWidgetListStyles: DiscontinuedWidgetListStyle = {
    dataTable: {},
    tableContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 10px;
            overflow: auto;
        `,
    },
    listWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 10px;
        `,
    },
    container: {
        gap: 20,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 40px 12px 40px;
                    `,
                    css`
                        margin: 40px 30px 40px;
                    `,
                    css`
                        margin: 58px 0 20px 0;
                    `,
                    css`
                        margin: 58px 40px 20px 8px;
                    `,
                    css`
                        margin: 58px 40px 20px 8px;
                    `,
                ])}
        `,
    },
    pagination: {
        cssOverrides: {
            pagination: css`
                border-top: 1px solid ${getColor("common.border")};
                padding-top: 15px;
            `,
        },
    },
    Rlptitle: {
        css: css`
            font-size: 21px;
            font-weight: bold;
            letter-spacing: 1.75px;
            line-height: 25px;
            color: #33333a;
            margin-left: 7px;
            text-transform: uppercase;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css``,
                        css`
                            font-size: 21px;
                            font-weight: bold;
                            letter-spacing: 1.75px;
                            line-height: 25px;
                            color: #33333a;
                            margin-left: 7px;
                        `,
                        css`
                            font-size: 14px;
                            font-weight: bold;
                            letter-spacing: 1.75px;
                            line-height: 25px;
                            color: #33333a;
                            margin-left: 7px;
                        `,
                        css`
                            font-size: 19px;
                            font-weight: bold;
                            letter-spacing: 1.75px;
                            line-height: 25px;
                            color: #33333a;
                            margin-left: 7px;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    subResourceNameLinkItem: {
        width: 12,
        css: css`
            padding: 0 !important;
            text-transform: capitalize;
        `,
    },

    columnHeader: {
        css: css`
            border: 0px;
            background: #fff;
            height: 40px;
            > span {
                font-size: 12px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 25px;
                color: #33333a;
                text-transform: uppercase;
            }
        `,
    },

    columnData: {
        css: css`
            border: 0px;
            &:nth-child(odd) {
                background: #f4f6fa;
            }
            &:nth-child(even) {
                background-color: #fff;
            }
            > td[class^="DataTableCellBase"] {
                padding: 13px;
            }
        `,
    },

    cellCss: {
        css: css`
            height: 40px;
            border: 0px;
            text-transform: capitalize;
            > span {
                font-size: 16px;
                letter-spacing: 0;
                line-height: 24px;
                text-align: justify;
                color: #33333a;
            }
        `,
    },

    languageCellCss: {
        css: css`
            height: 40px;
            border: 0px;
            > span {
                font-size: 16px;
                letter-spacing: 0;
                line-height: 24px;
                text-align: justify;
                color: #33333a;
                text-transform: uppercase;
            }
        `,
    },
    modelLinks: {
        css: css`
            font-size: 16px;
            cursor: pointer;
            > span {
                font-size: 16px;
                letter-spacing: 0;
                line-height: 24px;
                text-align: justify;
                color: #33333a;
                text-transform: uppercase;
            }
        `,
    },
    ResourceListContainer: {
        width: [12, 12, 12, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 40px 10px 20px 0;
                    `,
                    css`
                        padding: 0;
                    `,
                    css`
                        padding: 0 10px;
                    `,
                    css`
                        padding: 0;
                        margin-bottom: 70px !important;
                    `,
                    css`
                        padding: 0;
                        margin-bottom: 70px !important;
                    `,
                ])}
        `,
    },
    ResourceListItemContainer: {
        width: [12, 12, 12, 9, 9],
        css: css`
            border: 1px solid #e1e1e1;
            background-color: #ffffff;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 0 !important;
                        margin-bottom: 70px !important;
                    `,
                    css`
                        margin: 0 20px !important;
                        margin-bottom: 70px !important;
                    `,
                    css`
                        margin-top: 20px !important;
                        margin-bottom: 70px !important;
                    `,
                    css`
                        margin-top: -63px !important;
                        margin-bottom: 70px !important;
                        padding: 10px 20.5px 10px 24.5px;
                    `,
                    css`
                        margin-top: -63px !important;
                        margin-bottom: 70px !important;
                        padding: 10px 20.5px 10px 24.5px;
                    `,
                ])}
        `,
    },

    ResourceContainer: {
        gap: 0,
        css: css`
            width: 100%;
            max-width: 1140px;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 30px;
                    `,
                    null,
                    css`
                        padding: 0 30px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    typeLinks: {
        color: "#2e64b0",
        css: css`
            font-size: 16px;
            text-transform: capitalize;
        `,
    },
    modelLinksText: {
        css: css`
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            text-align: justify;
            color: #33333a !important;
            text-transform: uppercase;
            cursor: default;
        `,
    },
    tableLinkData: {
        css: css`
                white-space: normal;
                > span {
                    font-size: 16px;
                    letter-spacing: 0;
                    color: #006bc0 !important;
                    line-height: 24px;
                    font-weight: 400;
                    text-align: justify;
                }
                @media (max-width:480px){
                    white-space: nowrap;
                }
            }
        `,
    },
    tableDataColThree: {
        css: css`
            border: 0px !important;
            height: 40px;
            background: none !important;
            white-space: normal;
            > span {
                font-size: 16px;
                letter-spacing: 0;
                color: #33333a !important;
                line-height: 24px;
                font-weight: 400;
                text-align: justify;
            }
            @media (max-width: 480px) {
                white-space: nowrap;
            }
        `,
    },
    searchTextField: {
        iconProps: { src: Search },
        cssOverrides: {
            formField: css`
                > div {
                    padding-top: 20px;
                    border-bottom: 2px solid rgba(0,0,0,0.1);
                    padding-bottom: 20px;
                    > span {
                        left: 14px !important;
                        top: 24px !important;
                        width: 29px !important;
                        height: 34px !important;
                        padding: 0px !important;
                        > svg {
                            stroke-width: 1;
                            color: #33333a !important;
                            height: 18px;
                            width: 18px;
                        }
                    }
                }
            `,
            inputSelect: css`
                border: 1px solid #cccccc;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 42px;
                height: 42px;
                width: 100% !important;
                padding: 10px 10px 10px 46px;
                ::placeholder {
                    color: rgba(0, 0, 0, 0.5);
                    font-size: 16px;
                    letter-spacing: 0;
                    right:5px;
                }
                @media all and (max-width: 992px) and (min-width: 0px) {
                    border: 1px solid #cccccc;
                    &:focus {
                        border: 1px solid #cccccc !important;
                        padding-left: 46px !important;
                        padding-right: 10px !important;
                    }
                }

                &:focus {
                    border: 1px solid rgba(0, 0, 0, 0.1);
                    padding-left: 40px;
                    color: rgba(0, 0, 0, 0.5);
                    font-size: 16px;
                    letter-spacing: 0;
                    padding-left: 46px !important;
                    padding-right: 10px !important;
                }
            `,
        },
    },
};

const styles = DiscontinuedWidgetListStyles;
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

class INTDiscontinuedProductAcordion extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            ...this.state,
            isFiltered: false,
            typesData: this.props.typesList,
            categoriesData: this.props.categoriesList,
            discontinuedProductListData: this.props.discontinuedProductsList,
        };
    }
    
    componentDidMount() {
        this.updateDiscontinuedProductData();
    }
    updateTypeFilter = (filteredData: DiscontinuedProductList[]) => {
        const discontinuedProductListFilter = getDiscontinuedProductListFilters();
        const types: string[] = filteredData.map((dp: { fields: { type: string } }) => {
            return dp.fields.type;
        });
        const typesListFiltered = types.filter(function (elem, pos) {
            // eslint-disable-next-line eqeqeq
            return types.indexOf(elem) == pos;
        });
        const typesList: FacetModel[] = typesListFiltered.map<FacetModel>(o => ({
            id: o,
            name: o,
            count: 1,
            selected: discontinuedProductListFilter.typeFilters.indexOf(o) !== -1,
        }));
        this.setState({
            typesData: typesList,
        });
    };

    updateCategoryFilter = (filteredData: DiscontinuedProductList[]) => {
        const discontinuedProductListFilter = getDiscontinuedProductListFilters();
        const categories: string[] = filteredData.map((dp: { fields: { category: string } }) => {
            return dp.fields.category;
        });
        const categoriesListFiltered = categories.filter(function (elem, pos) {
            // eslint-disable-next-line eqeqeq
            return categories.indexOf(elem) == pos;
        });
        const categoriesList: FacetModel[] = categoriesListFiltered.map<FacetModel>(o => ({
            id: o,
            name: o,
            count: 1,
            selected: discontinuedProductListFilter.categoryFilters.indexOf(o) !== -1,
        }));
        this.setState({
            categoriesData: categoriesList,
        });
    };

    updateDiscontinuedProductData = (_filterType = "onLoad", _isSelected = false, _isValue = "") => {
        const discontinuedProducts: DiscontinuedProductList[] = this.props.discontinuedProductsList;
        const discontinuedProductsListFilter = getDiscontinuedProductListFilters();
        let filteredData: DiscontinuedProductList[];
        if (!discontinuedProducts) {
            return null;
        }
        filteredData = discontinuedProducts;
        if (window.parent.location.href.indexOf("isFiltered=true") !== -1) {
            this.updateCategoryFilter(filteredData);
            if (discontinuedProductsListFilter.categoryFilters.length !== 0) {
                const filteredCategoryData = filteredData.filter(
                    elem => discontinuedProductsListFilter.categoryFilters.indexOf(elem.fields.category) !== -1,
                );
                filteredData = filteredCategoryData;
                this.updateTypeFilter(filteredData);
            }
            this.updateTypeFilter(filteredData);
            if (discontinuedProductsListFilter.typeFilters.length !== 0) {
                const filteredTypeData = filteredData.filter(
                    elem => discontinuedProductsListFilter.typeFilters.toLocaleString().toLowerCase().indexOf(elem.fields.type.toLowerCase()) !== -1,
                );
                filteredData = filteredTypeData;
                this.updateCategoryFilter(filteredData);
            }
            if (_filterType.length !== 0 && _filterType == "discontinuedProduct" && _isValue.length !== 0) {
                const filteredModelData = filteredData.filter(elem => {
                    if (elem.fields.discontinuedProductId && elem.fields.replacementProductId
                        && elem.fields.discontinuedProductId.toLowerCase().indexOf(_isValue.toLowerCase()) !== -1 || 
                        elem.fields.replacementProductId.toLowerCase().indexOf(_isValue.toLowerCase()) !== -1) {
                        return true;
                    }
                    return false;
                });
                filteredData = filteredModelData;
                this.updateCategoryFilter(filteredData);
                this.updateTypeFilter(filteredData);
            }
            this.setState({
                isFiltered: true,
                discontinuedProductListData: filteredData,
            });
        } else {
            this.props.removeAllDiscontinuedProductsFilters();
            this.setState({
                isFiltered: false,
                discontinuedProductListData: filteredData,
            });
            this.updateCategoryFilter(filteredData);
            this.updateTypeFilter(filteredData);
        }
    };
    updateDPFilter = (_filterType: string, filterList: FacetModel[]) => {
        const dpFilter = getDiscontinuedProductListFilters();
        const filteredList = filterList.map(fil => fil.id);
        if (_filterType === "category") {
            for (const filter of dpFilter.categoryFilters) {
                if (filteredList.indexOf(filter) === -1) {
                    this.props.removeDiscontinuedProductsFilters({ filterId: filter, type: _filterType });
                }
            }
        } 
        else if (_filterType === "type") {
            for (const filter of dpFilter.typeFilters) {
                if (filteredList.indexOf(filter) === -1) {
                    this.props.removeDiscontinuedProductsFilters({ filterId: filter, type: _filterType });
                }
            }
        }
    };
    render() {
        const onChangeType = (facet: FacetModel) => {
            // eslint-disable-next-line eqeqeq
            const objIndex = this.state.typesData.findIndex(obj => obj.id == facet.id);
            const tempTypeData = [...this.state.typesData];
            this.updateDPFilter("type", tempTypeData);
            const type = { ...tempTypeData[objIndex] };
            type.selected = !facet.selected;
            tempTypeData[objIndex] = type;
            if (type.selected) {
                this.props.addDiscontinuedProductsFilters({ filterId: type.id, type: "type" });
            } else {
                this.props.removeDiscontinuedProductsFilters({ filterId: type.id, type: "type" });
            }
            this.setState({ typesData: tempTypeData });
            const searchParam = new URLSearchParams(window.location.hash.split("?")[1]);
            searchParam.set("isFiltered", "true");
            window.location.hash = `?${searchParam.toString()}`;
            this.updateDiscontinuedProductData("type", type.selected, undefined);
        };
        const onChangeCategory = (facet: FacetModel) => {
            // eslint-disable-next-line eqeqeq
            const objIndex = this.state.categoriesData.findIndex(obj => obj.id == facet.id);
            const tempCategoryData = [...this.state.categoriesData];
            this.updateDPFilter("category", tempCategoryData);
            const category = { ...tempCategoryData[objIndex] };
            category.selected = !facet.selected;
            tempCategoryData[objIndex] = category;
            if (category.selected) {
                this.props.addDiscontinuedProductsFilters({ filterId: category.id, type: "category" });
            } else {
                this.props.removeDiscontinuedProductsFilters({ filterId: category.id, type: "category" });
            }
            this.setState({ categoriesData: tempCategoryData });
            const searchParam = new URLSearchParams(window.location.hash.split("?")[1]);
            searchParam.set("isFiltered", "true");
            window.location.hash = `?${searchParam.toString()}`;
            this.updateDiscontinuedProductData("category", category.selected, undefined);
        };
        const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const newQuery = event.target.value;
            const searchParam = new URLSearchParams(window.location.hash.split("?")[1]);
            searchParam.set("isFiltered", "true");
            window.location.hash = `?${searchParam.toString()}`;
            this.updateDiscontinuedProductData("discontinuedProduct", true, newQuery);
        };
        return (
            <>
                <GridContainer {...styles.ResourceContainer}>
                    <GridItem {...styles.ResourceListContainer}>
                        <GridContainer {...styles.container}>
                            <StyledWrapper
                                css={css`
                                    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
                                    width: 100%;
                                `}
                            >
                                <StyledWrapper
                                    css={css`
                                        display: flex;
                                        margin-bottom: 19px;
                                    `}
                                >
                                    <StyledWrapper
                                        css={css`
                                            display: flex;
                                        `}
                                    >
                                        <LazyImage
                                            src="/UserFiles/Images/MiniLogo.jpg"
                                            css={css`
                                                width: 20px;
                                            `}
                                        />
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        <Typography as="h3" {...styles.Rlptitle}>
                                            {this.props.fields.title}
                                        </Typography>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                            <TextField
                                {...styles.searchTextField}
                                onChange={handleSearchInputChange}
                                placeholder={translate("Search by Model #")}
                                type="text"
                                data-test-selector="discontinuedtProdsSearchWithin"
                                id="discontinuedtProdsKeywordSearch"
                            />
                            <GridItem {...styles.subResourceNameLinkItem} id="dataCategoryGrid">
                                    <DiscontinuedProductsListFiltersAccordionSection
                                        key="category"
                                        title={translate("Category")}
                                        facets={this.state.categoriesData}
                                        onChangeFacet={onChangeCategory}
                                        showMoreLimit={5}
                                        expandByDefault={!isMobile().any}
                                    />
                            </GridItem>
                            <GridItem {...styles.subResourceNameLinkItem} id="dataTypeGrid">
                                    <DiscontinuedProductsListFiltersAccordionSection
                                        key="type"
                                        title={translate("Type")}
                                        facets={this.state.typesData}
                                        onChangeFacet={onChangeType}
                                        showMoreLimit={5}
                                        expandByDefault={!isMobile().any}
                                    />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.ResourceListItemContainer}>
                        <StyledWrapper {...styles.tableContainer} data-test-selector="discontinuedtProdsListTable">
                            <DataTable {...styles.dataTable}>
                                <DataTableHead>
                                    <DataTableHeader {...styles.columnHeader}>{translate("DISCONTINUED")}</DataTableHeader>
                                    <DataTableHeader {...styles.columnHeader}>{translate("REPLACEMENT")}</DataTableHeader>
                                    <DataTableHeader {...styles.columnHeader}>{translate("TYPE")}</DataTableHeader>
                                    <DataTableHeader {...styles.columnHeader}>{translate("CATEGORY")}</DataTableHeader>
                                </DataTableHead>
                                <DataTableBody data-test-selector="discontinuedProductListTable_tableBody">
                                    {this.state.discontinuedProductListData?.map((discontinuedProduct: DiscontinuedProductList) => {
                                        return (
                                            <DataTableRow key={Math.random().toString()} {...styles.columnData}>
                                                <DataTableCell {...styles.languageCellCss}>
                                                         {discontinuedProduct.fields.isDiscontinuedProductAvailable ? (
                                                            <Link
                                                                href={`/Product/${discontinuedProduct.fields.discontinuedProductId}`}
                                                                {...styles.tableLinkData}
                                                            >
                                                                {discontinuedProduct.fields.discontinuedProductId}
                                                            </Link>
                                                        ) : (
                                                            discontinuedProduct.fields.discontinuedProductId
                                                        )}
                                                </DataTableCell>
                                                <DataTableCell {...styles.cellCss}>
                                                    {discontinuedProduct.fields.isReplacementProductAvailable ? (
                                                        <Link
                                                            href={`/Product/${discontinuedProduct.fields.replacementProductId}`}
                                                            {...styles.tableLinkData}
                                                        >
                                                            {discontinuedProduct.fields.replacementProductId}
                                                        </Link>
                                                        ) : (
                                                        discontinuedProduct.fields.replacementProductId
                                                    )}
                                                </DataTableCell>
                                                <DataTableCell {...styles.tableDataColThree}>
                                                    {discontinuedProduct.fields.type}
                                                </DataTableCell>
                                                <DataTableCell {...styles.tableDataColThree}>
                                                    {discontinuedProduct.fields.category}
                                                </DataTableCell>
                                            </DataTableRow>
                                        );
                                    })}
                                </DataTableBody>
                            </DataTable>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </>
        );
    }
}

const doumentsList: WidgetModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(INTDiscontinuedProductAcordion)),
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
            },
            {
                name: fields.discontinuedProductList,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.discontinuedProductId;
                },
                defaultValue: [],
                fieldType: "Translatable",
                sortOrder: 1,
                fieldDefinitions: [
                    {
                        name: fields.discontinuedProductId,
                        displayName: "Discontinued Product Id",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: fields.isDiscontinuedProductAvailable,
                        displayName: "Is Discontinued Product Available",
                        editorTemplate: "CheckboxField",
                        defaultValue: true,
                    },
                    {
                        name: fields.replacementProductId,
                        displayName: "Replacement Product Id",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: fields.isReplacementProductAvailable,
                        displayName: "Is Replacement Product Available",
                        editorTemplate: "CheckboxField",
                        defaultValue: true,
                    },
                    {
                        name: fields.type,
                        displayName: "Type",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: fields.category,
                        displayName: "Category",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
            },
        ],
    },
};

export default doumentsList;